
import React, { Component } from 'react';
import { connect } from 'react-redux';
import LANGUAGES_CONTROLLER from '../../controllers/languages'
import { SSelect } from '@avalara/skylab-sdk/react';

import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('DATA_DEFINED_DROPDOWN', LOG_LEVELS.ERROR);

class DataDefinedDropdown extends Component {


  render() {
    log.debug('render(): ', this.props);

    // Build options list for SSelect
    // Use value prop for selected state (fallback to isSelected for backwards compatibility)
    const selectedValue = this.props.value !== undefined ? this.props.value : this.props.isSelected;
    
    const optionsList = [
      {
        value: '',
        label: this.props.placeholder || '',
        selected: selectedValue === ''
      },
      ...this.props.definition.map((option) => {
        let oValue, oText;

        if (this.props.isSimpleArray) {
          oValue = option;
          oText = option;
        } else {
          oValue = Object.keys(option)[0];
          oText = option[oValue];
        }

        return {
          value: oValue,
          label: oText,
          selected: selectedValue === oValue
        };
      })
    ];

    return(
      <div>
        <label>{this.props.label}</label>
        <SSelect
          inputId={`data-defined-dropdown-${this.props.name}`}
          name={this.props.name}
          optionsList={optionsList}
          multiple={false}
          showSelectionCount={false}
          onS-select={(e) => {
            // Create a synthetic event that matches the original onChange signature
            const syntheticEvent = {
              target: { 
                name: this.props.name, 
                value: e.detail.item.value 
              }
            };
            this.props.onFieldChange(syntheticEvent);
          }}
        />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    languages: state.languages
  };
}


DataDefinedDropdown.defaultProps = {
  isSimpleArray: false
};

export default connect(mapStateToProps)(DataDefinedDropdown);
